import { useMemo } from "react";

export const useXAxisFormat = (granularity: number) => {
  const xAxisFormat = useMemo(() => {
    if (granularity === 1) {
      return "MMM D";
    }

    if (granularity === 2) {
      return "MMM YYYY";
    }

    return "YYYY";
  }, [granularity]);

  const tooltipFormat = useMemo(() => {
    if (granularity === 1) {
      return "MMM D, YYYY";
    }

    if (granularity === 2) {
      return "MMM, YYYY";
    }

    return "YYYY";
  }, [granularity]);

  return { xAxisFormat, tooltipFormat };
};
